import React, { useState, useEffect } from 'react';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { Helmet } from 'react-helmet';
import api from '../../services/api';
import { Spin } from 'antd';

const TermsConditions = () => {
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTerms();
  }, []);

const fetchTerms = async () => {
  try {
    const response = await api.get('/refund-policy');
    if (response.data.success && response.data.data) {
      setTerms(response.data.data);
    }
  } catch (error) {
    console.error('Error fetching terms & conditions:', error);
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="home-page">
      <Helmet>
        <title>Refund Policy - Startup Business Partners</title>
      </Helmet>
      
      <Navbar />
      
      <section className="sectionbg p-top-100 p-bottom-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-5">
                <div className="divider divider-simple text-center">
                  <h3>Refund Policy</h3>
                </div>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-lg-12">
              {loading ? (
                <div className="text-center">
                  <Spin size="large" />
                </div>
              ) : (
                <div className="card">
                  <div className="card-body">
                    {terms ? (
                      <>
                        {/* <h4 className="mb-4">{terms.title}</h4> */}
                        <div dangerouslySetInnerHTML={{ __html: terms.content }} />
                      </>
                    ) : (
                      <p>No Refund Policy Content  found.</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default TermsConditions;